<!-- 1、import AreaAction from '../../common/CitySelect' -->
<!-- 2、components: { AreaAction } -->
<!-- 3、<Area-action :width="110" :height="32" ></Area-action> -->
<template>
  <div class="city-select-con">
    <el-select class="select-Type" placeholder="请选择省份"  v-model="selectedCity.cityCode.provinceId" @change="getResult('province')">
      <el-option v-for="item in list" :value="item.id" :label="item.name"></el-option>
    </el-select>
    <el-select class="select-Type" placeholder="请选择城市"  v-model="selectedCity.cityCode.cityId" @change="getResult('city')">
      <el-option style="color:#333" v-show="city.length != 0" v-for="item in city" :value="item.id" :label="item.name"></el-option>
    </el-select>
    <el-select class="select-Type" placeholder="请选择地区" v-model="selectedCity.cityCode.districtId" @change="getResult('district')">
      <el-option style="color:#333" v-show="district.length != 0" v-for="item in district"
              :value="item.id" :label="item.name"></el-option>
    </el-select>
  </div>
  <!-- 横向展示 纵向展示 -->
  <!-- 提示文字 在后面还是下面 -->
  <!-- {code:1-、1-2、1-2-3 ,codeText:河北-张家口市-尚义县} -->
  <!-- codeText:{县:商议,省:河北,市:张家口市} -->
  <!-- <keep-alive></keep-alive> -->
</template>

<script>
import Configs from '../../lib/ChinaCityList'
  export default {
    data () {
      return {
        // 市区数据列表
        city: [],
        // 县数据列表
        district: [],
        // 所有数据列表
        list: [],
        // 拼装数据格式
        selectedCity: {
          cityCode: {
            provinceId: '',
            cityId: '',
            districtId: '',
          },
          cityText:{
            provinceText: '',
            cityText: '',
            districtText: '',
          },
          address: '',
        },
        AREA_JSON: {}
      }
    },
    mounted () {
      this.list = Configs.list;
      this.list.forEach(province=>{
        if (this.setAddress.province == province.name) {
          this.selectedCity.cityCode.provinceId = province.id
        }
        province.city_JSON = {}
        province.city.forEach(city=>{
          if (this.setAddress.province == province.name ) {
            this.city = province.city;
            if (this.setAddress.city == city.name) {
              this.selectedCity.cityCode.cityId = city.id
            }
          }
          city.district_JSON = {}
          city.district.forEach(district=>{
            if (this.setAddress.city == city.name) {
              this.district = city.district
              if (this.setAddress.district == district.name) {
                this.selectedCity.cityCode.districtId = district.id
              }
            }
            city.district_JSON[district.id] = district.name
          })
          province.city_JSON[city.id] = city
        })
        this.AREA_JSON[province.id] = province
      })
    },
    methods: {
      getListItem (list, target, targetAttr) {
        for ( let i = 0; i < list.length; i++ ) {
          if ( list[i][targetAttr] == target ) {
            return list[i]
          }
        }
      },
      getResult (type) {
        var id = this.selectedCity.cityCode.provinceId,
       childId = this.selectedCity.cityCode.cityId;



        // 获取二级列表
        if ( type == 'province' ) {
          this.selectedCity.cityCode.districtId = ''
          this.selectedCity.cityCode.cityId = ''
          this.district = []
          var cityList = this.getListItem(this.list, id, 'id')
          typeof cityList != 'undefined' ? this.city = cityList.city : this.city = []
        }

        // 获取三级列表
        if ( type == 'city' ) {
          this.selectedCity.cityCode.districtId = ''
          var districtList = this.getListItem(this.city, childId , 'id')
          typeof districtList != 'undefined' ? this.district = districtList.district : this.district = []
        }
        // 组织emit数据
        let oCode = this.selectedCity.cityCode
        let provinceId = Number( oCode.provinceId );
        let cityId = Number( oCode.cityId );
        let districtId = Number( oCode.districtId );

        if (provinceId == 0) {
          this.selectedCity.cityText.provinceText = '';
        }
        if (cityId == 0) {
          this.selectedCity.cityText.cityText = '';
        }
        if (districtId == 0) {
          this.selectedCity.cityText.districtText = '';
        }

        if ( provinceId ) {
          this.selectedCity.cityText.provinceText = this.AREA_JSON[provinceId].name
        }
        if ( provinceId && cityId) {
          this.selectedCity.cityText.cityText = this.AREA_JSON[provinceId].city_JSON[cityId].name
        }
        if ( provinceId && cityId && districtId) {
          this.selectedCity.cityText.districtText = this.AREA_JSON[provinceId].city_JSON[cityId].district_JSON[districtId]
        }

        // var selectedCity = this.selectedCity
        this.$emit('addressArea', this.selectedCity)
      },
    },
    props: {
      setAddress:{
        type:Object,
        default:{
          province: '',
          city: '',
          district: ''
        }
      }
    },
  }
</script>

<style lang="scss">
  .city-select-con{
    .el-input{
      width: 116px !important;
      margin-right: 10px;
    }
  }
</style>
